export default function isCard() {
  return ['wmcard', 'card'].includes(wkData.product.type);
}
